import request from "../utils/request";

export function setmgcmachine(data) {
    return request({
        url: "/machine/cerMgcMachine",
        data: data,
    });
}


export function cmsJPList(data) {
    return request({
        url: "/coinmachine/cmsJPList",
        data: data,
    });
}

export function getJpimage(data) {
    return request({
        url: "/coinmachine/getJpimage",
        data: data,
    });
}

export function setWawamachine(data) {
    return request({
        url: "/machine/cerWawaMachine",
        data: data,
    });
}

export function cerCoinMachine(data) {
    return request({
        url: "/machine/cerCoinMachine",
        data: data,
    });
}

export function selCoinMachine(data) {
    return request({
        url: "/machine/selCoinMachine",
        data: data,
    });
}

export function selYizhiMachine(data) {
    return request({
        url: "/machine/selYizhiMachine",
        data: data,
    });
}


export function selmgcmachine(data) {
    return request({
        url: "/machine/selMgcMachine",
        data: data,
    });
}

export function selWawaMachine(data) {
    return request({
        url: "/machine/selWawaMachine",
        data: data,
    });
}

export function setmgcxb(data) {
    return request({
        url: "/machine/setmgcxb",
        data: data,
    });
}


export function selmgcxb(data) {
    return request({
        url: "/machine/selmgcxb",
        data: data,
    });
}


export function updateMachineStatus(data) {
    return request({
        url: "/machine/updateMachineStatus",
        data: data,
    });
}

export function delXiaoban(data) {
    return request({
        url: "/machine/delXiaoban",
        data: data,
    });
}

export function videoOnline(data) {
    return request({
        url: "/machine/videoOnline",
        data: data,
    });
}

export function cmsWaWaGamelist(data) {
    return request({
        url: "/machine/cmsWaWaGamelist",
        data: data,
    });
}

export function getVideoUrl(data) {
    return request({
        url: "/machine/getVideoUrl",
        data: data,
    });
}


export function addwawa(data) {
    return request({
        url: "/moneyApply/addwawa",
        data: data,
    });
}


export function cmsCoinGamelist(data) {
    return request({
        url: "/machine/cmsCoinGamelist",
        data: data,
    });
}

export function cmsDevilcityGamelist(data) {
    return request({
        url: "/machine/cmsDevilcityGamelist",
        data: data,
    });
}

export function cmsKickUser(data)
{
    return request({
        url: "/devilcity/cmsKickUser",
        data: data,
    });
}


export function cmsWaringList(data) {
    return request({
        url: "/machine/cmsWaringList",
        data: data,
    });
}

export function cmsCleanWaring(data) {
    return request({
        url: "/machine/cmsCleanWaring",
        data: data,
    });
}

export function waringReply(data) {
    return request({
        url: "/machine/waringReply",
        data: data,
    });
}

export function updateCoinMachine(data) {
    return request({
        url: "/machine/updateCoinMachine",
        data: data,
    });
}

export function updateMgcMachine(data) {
    return request({
        url: "/machine/updateMgcMachine",
        data: data,
    });
}

export function updateWawaMachine(data) {
    return request({
        url: "/machine/updateWawaMachine",
        data: data,
    });
}

export function cmssetPushUrl(data) {
    return request({
        url: "/machine/cmssetPushUrl",
        data: data,
    });
}

export function caozuopush(data) {
    return request({
        url: "/machine/caozuopush",
        data: data,
    });
}

export function setYfsConfig(data) {
    return request({
        url: "/dollmachine/setYfsConfig",
        data: data,
    });
}

export function cmsSelYfsList(data) {
    return request({
        url: "/dollmachine/cmsSelYfsList",
        data: data,
    });
}


export function setYfsEnd(data) {
    return request({
        url: "/dollmachine/setYfsEnd",
        data: data,
    });
}

export function selYfsDel(data) {
    return request({
        url: "/dollmachine/selYfsDel",
        data: data,
    });
}